class AboutController {
  constructor() {
    this.name = 'about';
  }
}

export default AboutController;



// WEBPACK FOOTER //
// ./client/app/components/about/about.controller.js